import { HttpContext, HttpErrorResponse } from '@angular/common/http';
import { SKIP_GLOBAL_ERROR_SNACKBAR } from '@core/interceptors/http-error.interceptor';
import { Observable, throwError } from 'rxjs';

// A refused installation request: its status, and the reason code customer-func puts in `detail`.
// A 422's detail is a list of schema errors and a request that never got an answer has no status,
// so neither carries a reason.
export interface InstallationRefusal {
  status: number;
  reason: string | null;
}

// Takes a refusal the installation services already made as it is.
export function toRefusal(error: unknown): InstallationRefusal {
  if (error instanceof HttpErrorResponse) {
    const detail: unknown = error.error?.detail;
    return { status: error.status, reason: typeof detail === 'string' ? detail : null };
  }
  if (isRefusal(error)) {
    return error;
  }
  return { status: 0, reason: null };
}

function isRefusal(error: unknown): error is InstallationRefusal {
  return (
    typeof error === 'object' &&
    error !== null &&
    typeof (error as InstallationRefusal).status === 'number' &&
    'reason' in error
  );
}

// For `catchError`: the request fails with its refusal rather than the raw response.
export function rethrowAsRefusal(error: unknown): Observable<never> {
  return throwError((): InstallationRefusal => toRefusal(error));
}

// The editors explain every refusal in place, so none reaches the global snackbar, which would
// show a bare reason code.
export function explainedInPlace(): HttpContext {
  return new HttpContext().set(SKIP_GLOBAL_ERROR_SNACKBAR, true);
}
